/*
  This is used to maintain a list of countries to consider opt out logic for
  In the future, this will be handled by UCM and Script Supplier will
  only consume UCM functions
*/
const OPT_OUT_PRIVACY_COUNTRIES = [
  'US',
];

export default OPT_OUT_PRIVACY_COUNTRIES;
